import Component from './abstract_component';
import $ from 'jquery';

const selector = '.wp-block-columns .wp-block-pluss-info-card';

let timeout;

const equalizeHeights = () => {
  let max = 0;

    const $cards = $(selector);
    $cards.height('auto');
    $cards.each(function () {
      max = Math.max(max, $(this).height());
    });

    $(selector).height(max);
}

class ProductCards extends Component {
  constructor() {
    super();
    this.cards = $('.wp-block-pluss-info-card');
  }

  _isReady() {
    return !!this.cards.length;
  }

  _run() {
    // equalize cards heights on load and resize
    $(window).on('load resize', () => {
      equalizeHeights();
    });
  }
}

export default ProductCards;
